// common
export const CLEAR_DATA = "CLEAR_DATA";

// items
export const SET_ITEMS = "SET_ITEMS";
export const UPDATE_FIELD = "UPDATE_FIELD";
export const DELETE_ITEM = "DELETE_ITEM";
export const UPDATE_SIGN_LINE = "UPDATE_SIGN_LINE";
export const UPDATE_SIGN_COORDINATE = "UPDATE_SIGN_COORDINATE";
export const DELETE_SIGN_LOCATION = "DELETE_SIGN_LOCATION";
export const ADD_SIGN_LOCATION = "ADD_SIGN_LOCATION";
export const TOGGLE_ARCHIVE_STATE = "TOGGLE_ARCHIVE_STATE";
export const ADD_ITEM = "ADD_ITEM";
export const ADD_PATTERN = "ADD_PATTERN";
export const DELETE_PATTERN = "DELETE_PATTERN";
export const IMPORT_TRANSLATIONS = "IMPORT_TRANSLATIONS";
export const MOVE_COLLECTION_BULK = "MOVE_COLLECTION_BULK";
export const SCRIPT_REPLACE_BLANK_TRANSLATIONS_WITH_NULL =
  "SCRIPT_REPLACE_BLANK_TRANSLATIONS_WITH_NULL";

// editor
export const ADD_TAG = "ADD_TAG";
export const SET_SORT = "SET_SORT";
export const TOGGLE_SELECT = "TOGGLE_SELECT";
export const SET_ALL_SELECT = "SET_ALL_SELECT";
export const SET_METADATA = "SET_METADATA";
export const ADD_COLLECTION = "ADD_COLLECTION";
export const DELETE_COLLECTION = "DELETE_COLLECTION";

// undo
export const UNDO = 'UNDO';
export const REDO = 'REDO';
